import { Component, Inject, OnInit, SecurityContext } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as xml2js from 'xml2js';

@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.scss']
})
export class ErrorPopupComponent implements OnInit {

  public genericErrorMsg: any = '';
  public apiErrorMsg: any;
  public showErrorDetail: boolean = false;

  constructor(
    private domSanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<ErrorPopupComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit() {

    if (this.data && this.data.error) {
      let error = this.data.error;
      this.genericErrorMsg = 'The server encountered an error and could not complete your request, Please retry or contact ASG support for assistance';

      if (error && (error.status == 500 || error.status == 502 || error.status == 504 || error.status == 503 || error.status == 403 || error.status == 404)) {
        if(error && error.error && error.error.responseBody) {
          this.setUnknownFormError(error);
        } else {
          if(error && error.message) {
            this.apiErrorMsg = error.message;
            this.setUnknownFormError(error);
          } else if (error && error.error && error.error.message) {
            this.apiErrorMsg = error.message;
          } else if (error && error.error && error.error.apierror) {
            this.apiErrorMsg = error.error.apierror.message;
          }
        }
      } else if(error.status == 400 && error.error && error.error.responseBody && error.error.responseBody == '400 Bad Data- Unable to identify the Form. Please add "Form name" and try again.') {
        this.apiErrorMsg = 'Match not found. Please enter the Form name and try again.';
      } else if(error.status == 400 && !error.error) {
        if(error && error.message) {
          this.apiErrorMsg = error.message;
        } else if (error && error.error && error.error.apierror) {
          this.apiErrorMsg = error.error.apierror.message;
        }

      } else if (error.status == 50 && error.message) {
        this.genericErrorMsg = error.message;
      } else {
        if(error && error.error && Object.keys(error.error).length > 0) {
          if (error.error.responseBody && error.error.responseBody != '') {
            this.setUnknownFormError(error);
          } else {
            this.apiErrorMsg = error.error;
          }
        }
      }
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  public setUnknownFormError(error) {
    if (this.data.responseType && this.data.responseType.toLowerCase() == 'json') {
      let tempJSON = JSON.parse(error.error.responseBody);
      if (typeof tempJSON == 'object') {
        if (tempJSON.ACORD && tempJSON.ACORD.ACORD && tempJSON.ACORD.ACORD[0] && tempJSON.ACORD.ACORD[0].formName && tempJSON.ACORD.ACORD[0].formName.toLowerCase() == 'unknown' && !this.data.formName) {
          this.apiErrorMsg = 'Unable to identify the Form. Please add "Form name" and try again';
        } else {
          this.apiErrorMsg = 'Unable to identify the form. Please contact ASG support';
        }
      }
    } else if (this.data.responseType && this.data.responseType.toLowerCase() == 'xml') {
      const parser = new xml2js.Parser({ strict: true, trim: false });
      parser.parseString(error.error.responseBody, (err, result) => {
        if (result && result.ACORD && result.ACORD.ACORD && result.ACORD.ACORD[0] && result.ACORD.ACORD[0].$ && result.ACORD.ACORD[0].$.formName && result.ACORD.ACORD[0].$.formName.toLowerCase() == 'unknown' && !this.data.formName) {
          this.apiErrorMsg = 'Unable to identify the Form. Please add "Form name" and try again';
        } else {
          this.apiErrorMsg = 'Unable to identify the form. Please contact ASG support';
        }
      });
    } else if (this.data.responseType && this.data.responseType.toLowerCase() == 'csv') {
      let tempCSV = JSON.parse(error.error.responseBody);

      let lines = tempCSV[0].split("\n");
      let headers = lines[0].split(",");
      let result = {};
      let dataline = lines[1].split(",");

      for (let j = 0; j < headers.length; j++) {
        result[headers[j]] = dataline[j].replace(/[\"]/g, '');
      }

      if (result && result['formName'] && result['formName'].toLowerCase() == 'unknown' && !this.data.formName) {
        this.apiErrorMsg = 'Unable to identify the Form. Please add "Form name" and try again';
      } else {
        this.apiErrorMsg = 'Unable to identify the form. Please contact ASG support';
      }
    }
  }
}
